import dayjs from 'dayjs'
import {useCallback} from 'react'
import {useDayjs} from '../states/dayJs'

export const LongDate = 'LL' as const
export const MediumDate = 'MMMM YYYY' as const
export const ShortDate = 'L' as const
export type DateFormat = typeof ShortDate | typeof MediumDate | typeof LongDate

export const useDateFormatter = (): ((date: string | undefined, format: DateFormat) => string) => {
  const dayJs = useDayjs()

  return useCallback((date: string | undefined, format: DateFormat): string => {
    return dayJs(date).format(format)
  }, [dayJs])
}

export const getDateTimeReadableIso = (date?: string): string => {
  return dayjs(date).format('YYYY-MM-DD HH-mm-ss')
}
export const getDateTimeIso = (date?: string): string => {
  return dayjs(date).toISOString()
}
export const getDateTimeUnix = (date?: string): number => {
  return dayjs(date).unix()
}
export const getDateDiff = (date: string): number => {
  return dayjs().diff(date, 'days', true)
}
